import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { InternationalizationContext, InternationalizationProvider, useInternationalization } from '@packages/i18n';
import intl, { DEFAULT_LOCALE, changeLanguage, translations } from '@utils/intl';
export const LanguageContext = createContext({
    locale: DEFAULT_LOCALE,
    intl,
});
const LanguageContextBridge = ({ children }) => {
    const intlInstance = useIntl();
    const { locale, setLocale } = useInternationalization();
    const normalizedLocale = translations[locale]
        ? locale
        : DEFAULT_LOCALE;
    useEffect(() => {
        changeLanguage(normalizedLocale);
    }, [normalizedLocale]);
    const handleChangeLanguage = useCallback((nextLocale) => {
        void setLocale(nextLocale);
    }, [setLocale]);
    const value = useMemo(() => ({
        locale: normalizedLocale,
        intl: intlInstance,
        handleChangeLanguage,
    }), [normalizedLocale, intlInstance, handleChangeLanguage]);
    return _jsx(LanguageContext.Provider, { value: value, children: children });
};
export const LanguageProvider = (props) => {
    const internationalizationContext = useContext(InternationalizationContext);
    if (!internationalizationContext) {
        return (_jsx(InternationalizationProvider, { defaultLocale: DEFAULT_LOCALE, messages: translations, children: _jsx(LanguageContextBridge, { ...props }) }));
    }
    return _jsx(LanguageContextBridge, { ...props });
};
